import { PluginWorkSite } from 'rwl-shared/dist/models';
import styled from 'styled-components6';

const JobCarouselCardContainer = styled.div`
    overflow: hidden;
    padding: var(--rwl-spacing-md);
    cursor: pointer;
    display: flex;
    align-items: center;
    aspect-ratio: 1;
    flex: 1;
    position: relative;

    border: 1px solid var(--rwl-palette-gray-300);
    box-shadow: none;
    transition: 0.4s;
    border-radius: var(--rwl-radius-sm);

    margin: var(--rwl-spacing-md);

    flex-direction: column;
    gap: var(--rwl-spacing-md);
    justify-content: space-evenly;

    background-color: var(--rwl-background-primary);
    //this might end up configurable
    min-height: 200px;
    width: 200px;
`;

export const JobCarouselCard = ({ content }: { content: PluginWorkSite }) => {
    return <JobCarouselCardContainer>{content.id}</JobCarouselCardContainer>;
};
